export class AppSettings {
    static hideLoginUntilRefresh = false;
}
